<ubl-quote [data]="quoteData"></ubl-quote>